import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  mounted () {
    this.options = {
      legend: {
        display: false
      },
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            display: false,
            stacked: true,
            id: 'bar-x-axis1',
            barThickness: 70,
            barPercentage: 0.2
          }
        ],
        yAxes: [
          {
            display: false,
            stacked: false,
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    }
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/charts/BarChart.js